import cn from 'classnames';
import styles from './LocationButton.module.scss';
import { ArrowIcon } from '../Icons';

type LocationButtonProps = {
  className?: string;
  name: string;
  onClick: () => void;
  address: string;
};

export function LocationButton({
  className,
  name,
  onClick,
  address,
}: LocationButtonProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName}>
      <img src="/svg/sofa-outline.svg" alt="shop" className={styles.icon} />
      <button type="button" className={styles.info} onClick={onClick}>
        <div className={styles.heading}>
          <span className={styles.name}>{name}</span>
          <ArrowIcon size={20} color="#00000066" />
        </div>
        <p className={styles.address}>{address}</p>
      </button>
    </div>
  );
}
